import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ERROR_LABEL: `${cleanedFilename(__filename)}-error-label`,
};
